// src/lib/cn.ts
//
// `cn` (className) utility that combines:
//   - `clsx` for conditional class joining (handles strings, arrays, objects,
//     falsy values)
//   - `tailwind-merge` for resolving Tailwind class conflicts
//     (when both `px-2` and `px-4` are present, the later one wins)
//
// Usage:
//   cn("base-class", isActive && "active-class", { "disabled": true })
//   cn("text-white", "text-black") // -> "text-black" (tailwind-merge)

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combine and merge Tailwind class names, resolving conflicts.
 *
 * @param inputs - Any number of class values (strings, arrays, objects, falsy)
 * @returns A single deduplicated className string
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}